import { ReactNode } from 'react';

import { ChevronDown, Plus } from 'lucide-react';

import { Button } from '../../../../components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../../../components/ui/collapsible';
import { cn } from '../../../../lib/utils';

interface SectionCardProps {
  children: ReactNode;
  count: number;
  defaultOpen?: boolean;
  headerExtras?: ReactNode;
  onUpload: () => void;
  subtitle?: string;
  title: string;
}

const SectionCard = ({
  children,
  count,
  defaultOpen = false,
  headerExtras,
  onUpload,
  subtitle,
  title,
}: SectionCardProps) => (
  <Collapsible defaultOpen={defaultOpen}>
    <section className="overflow-hidden rounded-xl border border-border-subtle bg-bg-surface">
      <header className="flex items-center gap-3 bg-bg-surface-raised px-5 py-4">
        <CollapsibleTrigger
          className={cn(
            'group flex min-w-0 flex-1 items-center gap-3 text-left',
            '[&[data-state=closed]>svg]:rotate-[-90deg]'
          )}
        >
          <ChevronDown className="size-4 shrink-0 text-brand-navy transition-transform duration-200" />
          <h3 className="m-0 font-display text-lg font-bold text-brand-navy">{title}</h3>
          {subtitle && <span className="truncate text-xs font-normal text-text-muted">({subtitle})</span>}
          <span className="rounded-full bg-brand-vivid px-2.5 py-0.5 text-xs font-bold text-text-inverse">{count}</span>
        </CollapsibleTrigger>
        {headerExtras}
        <Button
          aria-label={`Subir ${title}`}
          className="ml-auto shrink-0 rounded-full bg-brand-vivid text-text-inverse hover:bg-brand-sky-dark"
          onClick={onUpload}
          size="icon"
          type="button"
        >
          <Plus className="size-5" />
        </Button>
      </header>
      <CollapsibleContent className="border-t border-border-subtle">{children}</CollapsibleContent>
    </section>
  </Collapsible>
);

export default SectionCard;
